import { render, staticRenderFns } from "./ForgotPasswordV1.vue?vue&type=template&id=3648124c"
import script from "./ForgotPasswordV1.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordV1.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordV1.vue?vue&type=style&index=0&id=3648124c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports